$(function () {
	var swiper = new Swiper('.swiper-container', {
		navigation: {
			nextEl: '.swiper-button-next',
			prevEl: '.swiper-button-prev',
		},
		loop: true,
		observer: true,
		observeParents: true,
		/*  autoplay: {
			delay: 3000
		  },*/
		pagination: {
			el: '.swiper-pagination',
			type: 'bullets',
			/*clickable: true,*/
		},
      simulateTouch: false,/*クリックでスワイプしない*/
		slidesPerView: 2,
		loopedSlides: 3,
		/*centeredSlides : true,*/
		slideToClickedSlide: true,
		spaceBetween: 16,
		slidesPerGroup: 1,
		breakpoints: {
			// 768px以上の場合
			768: {
				slidesPerView: 3,
        spaceBetween: 20,
			}
		}
	});
	
	/*lazyload*/
	var lazyloadImages;

	if ("IntersectionObserver" in window) {
		lazyloadImages = document.querySelectorAll(".bg-lazy");
		var imageObserver = new IntersectionObserver(function (entries, observer) {
			entries.forEach(function (entry) {
				if (entry.isIntersecting) {
					var image = entry.target;
					image.classList.remove("bg-lazy");
					imageObserver.unobserve(image);
				}
			});
		});

		lazyloadImages.forEach(function (image) {
			imageObserver.observe(image);
		});
	} else {
		var lazyloadThrottleTimeout;
		lazyloadImages = document.querySelectorAll(".bg-lazy");

		function lazyload() {
			if (lazyloadThrottleTimeout) {
				clearTimeout(lazyloadThrottleTimeout);
			}

			lazyloadThrottleTimeout = setTimeout(function () {
				var scrollTop = window.pageYOffset;
				lazyloadImages.forEach(function (img) {
					if (img.offsetTop < (window.innerHeight + scrollTop)) {
						img.src = img.dataset.src;
						img.classList.remove('bg-lazy');
					}
				});
				if (lazyloadImages.length == 0) {
					document.removeEventListener("scroll", lazyload);
					window.removeEventListener("resize", lazyload);
					window.removeEventListener("orientationChange", lazyload);
				}
			}, 20);
		}

		document.addEventListener("scroll", lazyload);
		window.addEventListener("resize", lazyload);
		window.addEventListener("orientationChange", lazyload);
	}
  /*スムーススクロール*/
  $('a[href^="#"]').click(function(){
    var speed = 500;
    var href= $(this).attr("href");
    var target = $(href == "#" || href == "" ? 'html' : href);
    var position = target.offset().top;
    $("html, body").animate({scrollTop:position}, speed, "swing");
    return false;
  });
  
  
/*    $('.more-btn').on('click', function() {
    if( $(this).children().is('.open') ) {
      $(this).html('<p class="close">閉じる</p>').addClass('close-btn');
      $(this).parent().removeClass('slide-up').addClass('slide-down');
    } else {
      $(this).html('<p class="open">続きを読む</p>').removeClass('close-btn');
      $(this).parent().removeClass('slide-down').addClass('slide-up');
    }
  });*/
  
  
      /*アコーディオンコンテンツ*/
     //.accordion-wrapの中のdt要素がクリックされたら
	$('.accordion-contents dt').click(function(){
		//クリックされた.accordion-contentsの中のdt要素に隣接するdd要素が開いたり閉じたりする。
		$(this).next('dd').slideToggle();
     /*矢印の向きを変更*/
    $(this).toggleClass('open');
	});
  

  
});

$(function() {
    var nav_pos = $(".page-nav").offset().top;
var nav_height = $(".page-nav").outerHeight();
$(window).scroll(function () {
    if ($(this).scrollTop() > nav_pos) {
        $("body").css("padding-top", nav_height);
        $(".page-nav").addClass("is-fixed");
    } else {
        $("body").css("padding-top", 0);
        $(".page-nav").removeClass("is-fixed");
    }
});
});

